import { DigestApiFactory } from '@front-app/api-generated/digests-api';
import { createTRApi } from '@front-app/services/api';

const baseApi = createTRApi('');

baseApi.interceptors.request.use((config) => {
	const csrftoken = getCookie('csrftoken');
	if (csrftoken) {
		// eslint-disable-next-line no-param-reassign
		config.headers = {
			...config.headers,
			...getDjangoCsrfHeaders(csrftoken),
		};
	}
	return config;
});

export const digestsApi = DigestApiFactory(undefined, process.env.VUE_APP_API_DIGESTS_BASE_URL, baseApi);

export type DigestsApi = typeof digestsApi;

function getDjangoCsrfHeaders(csrfToken: string) {
	return {
		'X-CSRFToken': csrfToken,
	};
}

function getCookie(name: string) {
	let cookieValue = null;
	if (document.cookie && document.cookie !== '') {
		const cookies = document.cookie.split(';');
		for (let i = 0; i < cookies.length; i++) {
			const cookie = cookies[i].trim();
			// Does this cookie string begin with the name we want?
			if (cookie.substring(0, name.length + 1) === (`${name}=`)) {
				cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
				break;
			}
		}
	}
	return cookieValue;
}
